module.exports = __webpack_public_path__ + "img/donut-transparent.16bcda43.png";